//@ts-strict-ignore
import React from 'react';
import BlurTextField, { IBlurTextFieldProps } from './BlurTextField';

export type ISurchargeInputProps = Omit<IBlurTextFieldProps, 'infoMessage'> & { value: number };

export const SurchargeInput = (props: ISurchargeInputProps) => {
  let info: string | undefined = undefined;
  if (props.value < 0) {
    info = 'Discount';
  } else if (props.value > 0) {
    info = 'Surcharge';
  }

  return <BlurTextField {...props} infoMessage={info} />;
};

export type IDiscountInputProps = IBlurTextFieldProps & { value: number };

export const DiscountInput = (props: IDiscountInputProps) => {
  let info: string | undefined = undefined;
  if (props.value < 0) {
    info = 'Surcharge';
  } else if (props.value > 0) {
    info = 'Discount';
  }

  return <BlurTextField {...props} infoMessage={info} />;
};
